export default [
  '5df3a09ec5cff1e520c6e2de',
];



// WEBPACK FOOTER //
// ./src/modules/create_tutor/french_password_universities.js